import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import EquipmentOrganizationsText from '@/pages/Equipment/components/Common/EquipmentOrganizationsText'

interface IProps {
  organizations: IEquipment['organizations']
}

const EquipmentOrganizationsTableField = (props: IProps) => {
  return <EquipmentOrganizationsText organizations={props.organizations} />
}

export default EquipmentOrganizationsTableField
